var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6926,
    cy: 17.3077,
    r: 14.4231,
    fill: "#0077B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9238 10.3009C13.9238 11.1988 13.2401 11.9255 12.171 11.9255C11.1435 11.9255 10.4598 11.1988 10.4809 10.3009C10.4598 9.35936 11.1434 8.65387 12.1914 8.65387C13.2401 8.65387 13.9033 9.35936 13.9238 10.3009ZM10.5669 23.6676V13.2088H13.8173V23.6669H10.5669V23.6676Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4229 16.5466C16.4229 15.2421 16.3799 14.13 16.3369 13.2102H19.1602L19.3103 14.6431H19.3744C19.8022 13.9799 20.8714 12.9755 22.6037 12.9755C24.742 12.9755 26.3461 14.3872 26.3461 17.4657V23.669H23.0957V17.873C23.0957 16.5248 22.6255 15.6058 21.4493 15.6058C20.5507 15.6058 20.0165 16.226 19.8029 16.8243C19.717 17.0386 19.6746 17.3374 19.6746 17.6376V23.669H16.4242V16.5466H16.4229Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.9205329e193b51fd7b1fa7e28db30305.svg";
export { ForwardRef as ReactComponent };